<script setup lang="ts">
interface ItineraryLocationProps {
  location: string;
  country: string | undefined;
}

const props = defineProps<ItineraryLocationProps>();
</script>

<template>
  <div class="itinerary-location">
    <div class="location">
      {{ props.location }}
    </div>
    <div v-if="props.country" class="country">{{ props.country }}</div>
  </div>
</template>

<style scoped lang="scss">
.itinerary-location {
  display: flex;
  flex-direction: column;

  .location {
    @include font-label-m-bold;
  }

  .country {
    @include font-label-s-light;
    margin-top: var(--spacing-4);
  }
}
</style>
